// App language switcher. Wraps the @fajrarabi/ui LanguageSwitcher, computing
// the same path under the opposite locale from the current URL. A full
// navigation (anchor href) is intentional — it re-mounts the locale layout so
// the I18nProvider picks up the new locale cleanly.

import { LanguageSwitcher } from '@fajrarabi/ui';

import { pathInLocale, type Locale } from '~/lib/locale';

export function LangSwitcher({ locale, ariaLabel }: { locale: Locale; ariaLabel: string }) {
  const pathname = typeof window !== 'undefined' ? window.location.pathname : `/${locale}`;
  const arHref = pathInLocale(pathname, 'ar');
  const enHref = pathInLocale(pathname, 'en');

  return (
    <LanguageSwitcher
      locale={locale}
      arHref={arHref}
      enHref={enHref}
      arLabel="العربية"
      enLabel="English"
      ariaLabel={ariaLabel}
    />
  );
}
